import React from 'react';
import './Footer.less'; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section about">
          <p>提供最好的服務體驗給您。</p>
        </div>
        <div className="footer-section contact">
          <p>Email: contact@findbus.com</p>
          <p>Phone: (123) 456-7890</p>
        </div>
        <div className="footer-section social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} React Project by Coda Chen. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
